export default __webpack_public_path__ + "static/media/clear-pink.4444d86a.png";